import React from "react";
import GenericAdminCRUD from "../components/GenericAdminCRUD";

export default function ClientArchiveEditor() {
  return (
    <GenericAdminCRUD
      title="Arquivo de Entregas — Pastas"
      subtitle="Cadastre pastas do servidor da agência que o cliente pode acessar (Google Drive, Dropbox, ftp, etc)."
      path="client-archive"
      fields={[
        { key: "client_id", label: "Cliente *", type: "clientSelect" },
        { key: "name", label: "Nome da Pasta *", type: "text" },
        { key: "category", label: "Categoria", type: "select", options: ["Enxoval Criação", "Vídeos & Fotos", "Peças Finais", "Fontes e Assets", "Arquivos Fonte", "Materiais Extras"] },
        { key: "url", label: "URL da pasta (Drive, Dropbox…)", type: "text" },
        { key: "description", label: "Descrição", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "name", label: "Pasta" },
        { key: "category", label: "Categoria" },
        { key: "url", label: "URL", render: (it) => it.url ? "✓" : "—" },
        { key: "client_id", label: "Cliente", render: (it, { clients }) => clients.find((c) => c.id === it.client_id)?.company || "—" },
      ]}
    />
  );
}
